import React from "react";

import CaseCards from "components/CaseCards";

const Recommendations = ({ recommendations }) => {
  return (
    <section className="bg-gray-200 mt-12 pb-12 pt-4 px-4 xl:px-0">
      <div className="max-w-6xl	mx-auto pt-2">
        <h2 className="pb-6 font-semibold text-xl">More Cases to Explore</h2>
        <div className="flex flex-col items-center md:flex-row md:flex-wrap md:items-stretch md:justify-center md:-mx-3 lg:gap-6 lg:grid lg:grid-cols-3 lg:mx-0">
          <CaseCards cases={recommendations} />
        </div>
      </div>
    </section>
  );
};

export default Recommendations;
